import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import AdminLogin from "@/components/admin/AdminLogin";
import ImageSectionEditor from "@/components/admin/ImageSectionEditor";
import type { Session } from "@supabase/supabase-js";

const SECTIONS: ReadonlyArray<{ section: string; label: string; maxImages?: number }> = [
  { section: "hero-desktop", label: "Image héro — Desktop", maxImages: 1 },
  { section: "hero-mobile", label: "Image héro — Mobile", maxImages: 1 },
  { section: "property", label: "La maison (carousel)" },
  { section: "bedroom-chambre-1", label: "Suite parentale" },
  { section: "bedroom-chambre-2", label: "Chambre accès terrasse" },
  { section: "bedroom-chambre-3", label: "Chambre enfants" },
  { section: "room-sejour", label: "Pièce à vivre" },
  { section: "room-cuisine", label: "Cuisine" },
  { section: "room-salle-de-bain", label: "Salle de bain" },
  { section: "room-terrasse", label: "Terrasse (extérieur)" },
  { section: "region", label: "La région" },
];

export default function AdminPage() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div className="min-h-screen bg-gray-100 flex items-center justify-center text-gray-500">Chargement…</div>;
  }

  if (!session) {
    return <AdminLogin />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-gray-800">Admin – Ty Gwennili</h1>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-500">{session.user.email}</span>
            <button
              onClick={() => supabase.auth.signOut()}
              className="text-sm px-3 py-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 text-gray-700"
            >
              Déconnexion
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-8">
        {SECTIONS.map(({ section, label, maxImages }) => (
          <div key={section} className="bg-white rounded-xl shadow p-6 mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">{label}</h2>
            <ImageSectionEditor section={section} label={label} maxImages={maxImages} />
          </div>
        ))}
      </main>
    </div>
  );
}
